import { api } from "@/lib/api";
import { isDesktop } from "@/lib/desktop";
import { isKiosk } from "@/lib/kiosk";

export const APP_VERSION = "2026.06.5";

const ID_KEY = "orbit_device_id";
const NAME_KEY = "orbit_device_name";
const SHOP_KEY = "orbit_install_shop";

if (typeof window !== "undefined") {
  const q = new URLSearchParams(window.location.search);
  const dev = q.get("dev");
  if (dev && !dev.startsWith("%") && !dev.startsWith("$")) localStorage.setItem(NAME_KEY, dev.slice(0, 60));
  if (q.get("shop")) localStorage.setItem(SHOP_KEY, q.get("shop"));
  if (q.has("dev") || q.has("x")) { q.delete("dev"); q.delete("x"); const u = new URL(window.location.href); u.search = q.toString(); window.history.replaceState(null, "", u.toString()); }
}

export const installShop = () => localStorage.getItem(SHOP_KEY) || "";

export const deviceId = () => {
  let id = localStorage.getItem(ID_KEY);
  if (!id) { id = crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`; localStorage.setItem(ID_KEY, id); }
  return id;
};

export const sendHeartbeat = (kind, shop_id) => {
  if (!isDesktop() || !navigator.onLine) return;
  api.post("/devices/heartbeat", { device_id: deviceId(), name: localStorage.getItem(NAME_KEY) || undefined, kind, version: APP_VERSION, platform: navigator.userAgent.slice(0, 120), shop_id: shop_id || installShop() || undefined, kiosk: isKiosk() })
    .then((r) => runCommand(r.data?.cmd, r.data?.text)).catch(() => {});
};

export const MSG_EVT = "app:remote-message";

const runCommand = async (cmd, text) => {
  if (!cmd) return;
  if (cmd === "message") { window.dispatchEvent(new CustomEvent(MSG_EVT, { detail: { text, at: Date.now() } })); return; }
  if (cmd === "update") {
    try {
      const regs = await navigator.serviceWorker?.getRegistrations?.();
      await Promise.all((regs || []).map((r) => r.unregister()));
      const keys = await caches?.keys?.();
      await Promise.all((keys || []).map((k) => caches.delete(k)));
    } catch { /* ignore */ }
  }
  window.location.reload();
};

export const startHeartbeat = (kind, getShop) => {
  const tick = () => sendHeartbeat(kind, getShop?.());
  tick();
  const h = setInterval(tick, 60 * 1000);
  return () => clearInterval(h);
};
